(ns frontend.views.savings-waterfall
  "Frontend behaviour for the savings waterfall chart drawn in the browser."
  (:require
   [common.util  :as u]
   [shadow.graft :as graft]))

(defn- render-chart!
  "Draws the Vega spec the backend built into the chart's canvas element."
  [^js chart spec]
  (let [^js canvas (.querySelector chart "[data-chart-canvas]")]
    (-> (js/vega.View. (js/vega.parse (clj->js spec))
                       #js {:renderer  "svg"
                            :container canvas})
        (.runAsync))))

(defmethod graft/scion (u/->scion-id :frontend.views.savings-waterfall/render-chart)
  [{:keys [spec]} chart]
  (render-chart! chart spec))
